import React from 'react';

import {
    Alert,
    AlertTitle,
    Box,
    Divider,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import i18next from 'i18next';
import PropTypes from 'prop-types';

const ShowErrors = ({
    baseId,
    errors,
    severity = 'warning',
    title = i18next
        .t('Please correct the following error', { count: 2 })
        .concat(':'),
}) => {
    if (!errors || !Array.isArray(errors) || errors.length === 0) return null;
    return (
        <Alert severity={severity} sx={{ my: 2 }}>
            <AlertTitle variant="body2">{title}</AlertTitle>

            {errors.map((error, index) => (
                <Box key={`alert-box-${baseId}-${severity}-${index}`}>
                    <Typography variant="body2" key={index} type={severity}>
                        * {error}
                    </Typography>

                    {index < errors.length - 1 && <Divider sx={{ my: 1 }} />}
                </Box>
            ))}
        </Alert>
    );
};

ShowErrors.propTypes = {
    baseId: PropTypes.string,
    errors: PropTypes.array,
    severity: PropTypes.string,
    title: PropTypes.string,
};

export default ShowErrors;
